import firebase from "firebase/compat/app";
import 'firebase/compat/storage'
import 'firebase/compat/firestore'

const firebaseConfig = {
  apiKey: "AIzaSyAHoMyFT9XY9-g1nsXl11HFuOw4_8QH3Lw",
  authDomain: "keepsafe-a773c.firebaseapp.com",
  projectId: "keepsafe-a773c",
  storageBucket: "keepsafe-a773c.appspot.com",
  messagingSenderId: "367172803685",
  appId: "1:367172803685:web:cdd016abf322a473bafa8c",
  measurementId: "G-FK007B9ZQV"
};
// const firebaseConfig = {
//   apiKey: "XXXX",
//   authDomain: "XXXX",
//   projectId: "XXXX",
//   storageBucket: "XXXX",
//   messagingSenderId: "XXXX",
//   appId: "XXXX",
//   measurementId: "XXXX"
// };


firebase.initializeApp(firebaseConfig);


const projectStorage = firebase.storage() ; 
const projectFirestore = firebase.firestore() ; 

const timestamp = firebase.firestore.FieldValue.serverTimestamp ; 

export {projectStorage,projectFirestore ,timestamp}  ;

















